
import { IMRIFrameWrapperController } from "./iframe-wrapper.controller"

//#region Asset Imports

import './iframe-wrapper.scss'
import * as TEMPLATE from './iframe-wrapper.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrIframeWrapper'

export class IMRIFrameWrapperComponent implements ng.IComponentOptions {

    controller = ['$element', '$sce', IMRIFrameWrapperController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}
